function timelineDate(milestone) {
  const value = milestone.actual_completion_date || milestone.planned_completion_date || milestone.planned_start_date || milestone.planned_date;
  return value ? new Date(value).toLocaleDateString() : "Date pending";
}

export default function ClientTimeline({ milestones = [], progress = 0, summary = null }) {
  const timelineProgress = summary?.milestone_count ? summary.milestone_progress_percentage : progress;
  return (
    <div className="client-card timeline-card">
      <div className="section-heading-row">
        <div>
          <h2>Project Timeline</h2>
          <p>{summary?.current_milestone?.name ? `Current phase: ${summary.current_milestone.name}` : "Milestones will appear here once SCD prepares the project timeline."}</p>
        </div>
        {summary?.has_delayed_milestones && <span className="delivery-chip danger">Delayed item</span>}
      </div>
      <div className="progress-bar"><div className="progress-fill" style={{ width: `${timelineProgress || 0}%` }} /></div>
      <p>{timelineProgress || 0}% Complete</p>
      <div className="timeline timeline-vertical">
        {milestones.length === 0 ? <p className="empty-copy">No timeline milestones yet.</p> : milestones.map((milestone) => (
          <article key={milestone.id} className={`timeline-step timeline-step-${milestone.status}`}>
            <div>
              <strong>{milestone.name}</strong>
              {milestone.description && <p>{milestone.description}</p>}
            </div>
            <span>{milestone.status_label || milestone.status}</span>
            <small>{timelineDate(milestone)}</small>
          </article>
        ))}
      </div>
    </div>
  );
}